import React, { useMemo } from 'react';
import { CloseButton } from '@chakra-ui/react';
import { Colors, Text } from '@mercator-gcp/grout';
import { FlexColumn } from 'components/layout/FlexColumn/FlexColumn';
import { FlexRow } from 'components/layout/FlexRow';

type TStatusType = 'success' | 'error' | 'warning';

const toastContentStyle = (status: TStatusType) => {
  const backgroundColor = useMemo(() => {
    switch (status) {
      case 'error':
        return Colors.SystemColorNegative;
      case 'warning':
        return Colors.SystemColorWarning;
      case 'success':
      default:
        return Colors.ForestGreen900;
    }
  }, []);

  return {
    color: Colors.White,
    borderRadius: '4px',
    padding: 'padding_8',
    paddingRight: 'padding_16',
    columnGap: 'padding_16',
    backgroundColor,
  };
};

const toastLabelStyle = {
  flex: 1,
};

type TBasicToastProps = {
  onClose: () => void;
  status: TStatusType;
  label: string;
  title?: string;
};

const BasicToast = ({ onClose, status, title, label }: TBasicToastProps) => {
  return (
    <FlexRow sx={toastContentStyle(status)}>
      <CloseButton onClick={onClose} />
      <FlexColumn sx={toastLabelStyle}>
        {title && <Text.BodyBold>{title}</Text.BodyBold>}
        <Text sx={toastLabelStyle}>{label}</Text>
      </FlexColumn>
    </FlexRow>
  ) as React.ReactElement;
};

export default BasicToast;
